var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row row-no-padding row-col-separator-xl"},[_c('div',{staticClass:"col-md-12"},[(_vm.chartType == 'heatmap')?_c('apex-heatmap-chart',{attrs:{"data-url":_vm.chartDataUrl}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }